import React from "react";
import { Platform, StatusBar } from "react-native";
import { getHeaderStyleBasedOnProduct, isColorLight } from "./utils";
import { useThemeStore } from "@redux/slices/themeSlice";
import { HeaderProps } from "./types";
import { ProductCategory } from "@utils/constants";
import useAxiosInterceptor from "@components/common/hooks/useAxiosInterceptor";
import styled from "styled-components/native";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import ThreeDWebview from "@components/atoms/ThreeDWebview";
import { JewelryConfiguratorProvider } from "@scenes/configurator/JewelryConfigurator/Context/JewelryConfiguratorContext";

const Header = ({ hidden }: HeaderProps) => {
  const theme = useThemeStore();
  const { initStatus } = useOrgSettingsSlice();
  const { background } = getHeaderStyleBasedOnProduct(
    ProductCategory.DEFAULT,
    theme
  );
  // NOTE: do NOT call useNavigation() here — <Header /> is rendered directly
  // inside <NavigationContainer> in `src/navigations/index.tsx`, which is
  // outside of any Navigator. useNavigation() in that position throws
  // "The 'navigation' object hasn't been initialized yet". The interceptor
  // falls back to the attached navigationRef internally.
  useAxiosInterceptor();

  const threeDMediaObject = {
    three_d_data_type:
      initStatus?.three_d_settings?.three_d_data_type || "webgi",
    functionName: "init",
    params: {
      data: {},
      vjson: initStatus?.three_d_settings?.vjson,
    },
  };

  return (
    <>
      <StatusBar
        animated={true}
        backgroundColor={theme[background]}
        barStyle={
          Platform.OS === "android"
            ? isColorLight(theme[background])
              ? "dark-content"
              : "light-content"
            : "default"
        }
        showHideTransition={"slide"}
        hidden={hidden}
      />
      {/* Hidden 3D warmup iframe. Skip on Android: a display:none WebGL
          WebView keeps a GPU surface alive for the whole session and
          SIGSEGVs MediaTek drivers (near-null 0xf0) when another WebView
          mounts or the activity pauses. Visible 3D views still mount on demand. */}
      {Platform.OS !== "android" &&
      initStatus?.three_d_settings?.three_d_data_type ? (
        <JewelryConfiguratorProvider>
          <ThreeDParentContainer>
            <ThreeDWebview
              url={process.env.EXPO_PUBLIC_THREE_D_IFRAME_URL}
              extraSmallImage={false}
              allowScaleScript={false}
              showLoader={false}
              isClickable={true}
              injectJavaScript={threeDMediaObject}
              iframeKey={"vdb-initial-iframe"}
              threeDProperties={null}
            />
          </ThreeDParentContainer>
        </JewelryConfiguratorProvider>
      ) : null}
    </>
  );
};

const ThreeDParentContainer = styled.View`
  display: none;
`;

export default Header;
